import SubHeaders from '@/components/Headers/SubHeaders'
import AddIcons from '@/icons/AddIcons'
import useTabs from '@/hooks/useTabs'
import { paths } from '@/utils/path'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Tabs } from 'vnetwork-ui'
import { tabs } from './tabs'
import useAffiliatePolicyPermissions from '../../hooks/useAffiliatePolicyPermissions'

const List = () => {
    const { t } = useTranslation('affiliate')
    const navigate = useNavigate()
    const [policyModalOpen, setPolicyModalOpen] = useState(false)
    const { canCreatePolicy, canManagePolicies } =
        useAffiliatePolicyPermissions()
    const { TabComponent, TabProps, activeTab, setActiveTab } = useTabs({
        tabs: tabs(t, {
            policyModalOpen,
            setPolicyModalOpen,
            canManagePolicies,
        }),
        clearFilters: true,
    })

    // useTabs takes `?tab=` straight from the URL and only falls back to the
    // first tab when the param is absent — a deep link to a hidden tab would
    // otherwise render an empty page.
    useEffect(() => {
        if (activeTab === 'policies' && !canManagePolicies) {
            setActiveTab('confirmed')
        }
    }, [activeTab, canManagePolicies])

    const actions =
        activeTab === 'policies' && canManagePolicies && canCreatePolicy
            ? [
                  {
                      icon: <AddIcons />,
                      label: t('add_policy'),
                      onClick() {
                          setPolicyModalOpen(true)
                      },
                  },
              ]
            : activeTab !== 'policies' && canCreatePolicy
              ? [
                    {
                        icon: <AddIcons />,
                        label: t('add_affiliate'),
                        onClick() {
                            navigate(paths.affiliateCreate)
                        },
                    },
                ]
              : []

    return (
        <div>
            <SubHeaders
                actions={actions}
                breadcrumbs={[
                    {
                        path: paths.affiliatesList,
                        title: t('affiliate_manager'),
                    },
                ]}
            />
            <Tabs {...TabProps} />
            {TabComponent}
        </div>
    )
}

export default List
